<template>
  <v-card flat class="px-6">
    <v-row no-gutters>
      <v-col cols="12">
        <a type="primary" size="xsmall" @click="handleBack">
          <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
          {{ $t('message.actions.return') }}
        </a>
      </v-col>
    </v-row>
    <v-row no-gutters class="dubbing-container mb-6">
      <v-col cols="12" v-if="hasEditVideoPerm">
        <v-row no-gutters>
          <h4 class="body-bold-medium">
            {{ $t('message.ai.dubbings.dubbing') }}
          </h4>
        </v-row>
        <v-row no-gutters>
          <span class="body-regular-smaller neutral-40-light--text"
            >{{ $t('message.ai.dubbings.describeDubbings') }}
          </span>
          <a
            target="_blank"
            type="secondary"
            class="body-bold-smaller"
            :href="$t('message.ai.dubbings.knowMoreHereHref')"
          >
            {{ $t('message.ai.dubbings.knowMoreHere') }}
            <v-icon size="12">mdi-open-in-new</v-icon>
          </a>
        </v-row>
      </v-col>

      <div flat class="f-width" v-if="allDubbings.length || loadings.fetching">
        <template v-if="loadings.fetching">
          <v-skeleton-loader
            type="image"
            height="48px"
            style="margin-top: 1px"
          ></v-skeleton-loader>
          <v-skeleton-loader
            type="image"
            height="48px"
            style="margin-top: 1px"
          ></v-skeleton-loader>
          <v-skeleton-loader
            type="image"
            height="34px"
            width="148px"
            class="mt-4"
          ></v-skeleton-loader>
        </template>

        <template v-else>
          <template v-if="allDubbings.length">
            <v-row no-gutters class="mt-6">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex flex-column">
                  <span class="body-bold-base neutral-20-dark--text">{{
                    $i18next.t('message.ai.dubbings.availableDubs')
                  }}</span>
                  <span class="body-regular-smaller neutral-40-light--text">{{
                    $i18next.t('message.ai.dubbings.readyToUse')
                  }}</span>
                </div>
              </div>
              <div
                v-for="(dubbing, i) in allDubbings"
                :key="`${i}__dub`"
                class="f-width py-3 d-flex align-center justify-space-between"
              >
                <!-- <template v-if="dubbing.hasOwnProperty('metadata')">
                  <div class="d-flex align-center" style="gap: 16px">
                    <FlagCards
                      :items="[
                        getCountryCodeBySrcLang(
                          dubbing.metadata.to_lang || dubbing.metadata.from_lang
                        ),
                      ]"
                    />
                    <span class="body-regular-small neutral-20-dark--text">
                      {{
                        getLangLabelBySrclang(
                          dubbing.metadata.to_lang || dubbing.metadata.from_lang
                        )
                      }}
                    </span>
                  </div>
                  <div
                    class="d-flex align-center"
                    v-if="
                      dubbing.status === 'QUEUE' || dubbing.status === 'RUNNING'
                    "
                  >
                    <div
                      class="mr-1 d-flex align-center"
                      style="position: relative"
                    >
                      <v-progress-circular
                        :size="16"
                        :width="3"
                        color="brand"
                        style="top: 0; position: absolute"
                      ></v-progress-circular>
                      <v-progress-circular
                        :size="16"
                        :width="3"
                        color="brand"
                        indeterminate
                      ></v-progress-circular>
                    </div>
                    <span
                      :class="{
                        'neutral--text text--lighten-1': !$vuetify.theme.dark,
                      }"
                      >{{
                        $i18next.t(
                          'message.ai.dubbings.modal.auto.final_screen.title'
                        )
                      }}</span
                    >
                  </div>
                </template> -->
                <template>
                  <div class="d-flex align-center" style="gap: 16px">
                    <FlagCards
                      :items="[
                        getCountryCodeBySrcLang(
                          (dubbing.metadata || {}).to_lang ||
                            (dubbing.metadata || {}).from_lang ||
                            dubbing.lang
                        ),
                      ]"
                    />
                    <div class="d-flex flex-column">
                      <span
                        class="body-regular-small neutral-20-dark--text"
                        :class="{
                          'hidden-dub':
                            downloadDubbingItems[dubbing.id] &&
                            downloadDubbingItems[dubbing.id].hidden,
                        }"
                      >
                        {{
                          getLangLabelBySrclang(
                            (dubbing.metadata || {}).to_lang ||
                              (dubbing.metadata || {}).from_lang ||
                              dubbing.lang
                          )
                        }}
                      </span>
                      <span
                        :class="{
                          'hidden-dub':
                            downloadDubbingItems[dubbing.id] &&
                            downloadDubbingItems[dubbing.id].hidden,
                        }"
                        class="body-regular-smaller neutral-40-light--text"
                        v-if="!dubbing.type || dubbing.type !== 'UPLOADED'"
                      >
                        {{ $t('message.ai.dubbings.poweredBy') }} IIElevenLabs
                      </span>
                    </div>
                  </div>
                </template>

                <div class="d-flex align-center" style="gap: 16px">
                  <div
                    class="d-flex"
                    v-if="
                      downloadDubbingItems[dubbing.id] &&
                      downloadDubbingItems[dubbing.id].hidden
                    "
                  >
                    <div>
                      <v-tag type="neutral" class="ml-1">{{
                        $i18next.t('message.ai.dubbings.hidden')
                      }}</v-tag>
                    </div>
                  </div>
                  <div
                    class="d-flex align-center"
                    v-if="
                      (dubbing.status === 'ERROR' ||
                        dubbing.status === 'FAILED' ||
                        dubbing.status === 'CONVERTED' ||
                        dubbing.status === 'SKIPPED' ||
                        (!dubbing.status && dubbing.type !== 'UPLOADED')) &&
                      (!downloadDubbingItems[dubbing.id] ||
                        (downloadDubbingItems[dubbing.id] &&
                          !downloadDubbingItems[dubbing.id].hidden))
                    "
                  >
                    <span
                      v-if="
                        dubbing.status === 'ERROR' ||
                        dubbing.status === 'FAILED'
                      "
                    >
                      <v-tooltip bottom persistent v-model="showTooltipError">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="{
                              ...on,
                              mouseenter: (e) => {
                                showTooltipError = true
                                on.mouseenter && on.mouseenter(e)
                              },
                            }"
                          >
                            <v-tag type="error" class="ml-1">{{
                              $i18next.t('message.ai.dubbings.error')
                            }}</v-tag>
                          </div>
                        </template>
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            pointer-events: all !important;
                            z-index: 9999;
                          "
                          @mouseover="showTooltipError = true"
                          @mouseleave="showTooltipError = false"
                        >
                          <span style="white-space: pre-line">{{
                            $t('message.ai.dubbings.tooltipError.text')
                          }}</span>
                          <base-btn
                            type="neutral"
                            size="xsmall"
                            @click.stop="redirectLink"
                          >
                            <a
                              type="secondary"
                              target="_blank"
                              :href="
                                $t('message.ai.dubbings.tooltipError.href')
                              "
                              >{{ $t('message.embedModal.knowMore') }}
                              <v-icon size="16" class="ml-1"
                                >mdi-open-in-new</v-icon
                              >
                            </a>
                          </base-btn>
                        </div>
                      </v-tooltip>
                    </span>

                    <template v-else-if="dubbing.status === 'SKIPPED'">
                      <v-tooltip
                        v-if="dubbing.metadata.language_not_supported"
                        top
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="{ ...on, ...$listeners }"
                            class="mr-4 warning--text"
                          >
                            {{ $i18next.t('message.ai.noLanguageSupport') }}
                          </span>
                        </template>
                        <span>
                          {{
                            $i18next.t('message.ai.skippedWarningNotSupported')
                          }}
                        </span>
                      </v-tooltip>
                      <v-tooltip v-else top>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="{ ...on, ...$listeners }"
                            class="mr-4 warning--text"
                          >
                            {{ returnDubbingSkippedMessage }}
                          </span>
                        </template>
                        <span>
                          {{ $i18next.t('message.ai.skippedWarning') }}:
                          {{ getBlockingItem(dubbing) }}</span
                        >
                      </v-tooltip>
                    </template>
                    <div v-if="dubbing.status === 'CONVERTED'">
                      <div
                        v-if="
                          downloadDubbingItems[dubbing.id] &&
                          downloadDubbingItems[dubbing.id].loading &&
                          !downloadDubbingItems[dubbing.id].errorMsg.error
                        "
                        class="d-flex align-center mr-3 ml-2"
                        style="position: relative"
                      >
                        <v-progress-circular
                          :size="16"
                          :width="3"
                          color="brand"
                          style="position: absolute"
                        ></v-progress-circular>
                        <v-progress-circular
                          :size="16"
                          :width="3"
                          color="brand"
                          indeterminate
                        ></v-progress-circular>
                      </div>
                      <!-- <v-tooltip
                      top
                      :disabled="
                        downloadDubbingItems[dubbing.id] &&
                        !downloadDubbingItems[dubbing.id].errorMsg.error
                      "
                      v-else
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="{ ...on }">
                          <v-icon
                            color="primary"
                            class="mr-2"
                            size="24px"
                            @click="getDubbingAudio(dubbing)"
                            :disabled="
                              downloadDubbingItems[dubbing.id] &&
                              downloadDubbingItems[dubbing.id].errorMsg.error
                            "
                            @submit="
                              $emit('setDownloadServer', $event)
                              $nextTick(() => $refs.downloadAudioForm.submit())
                            "
                          >
                            mdi-download
                          </v-icon>
                        </div>
                      </template>
                      <span>
                        {{
                          $i18next.t('message.ai.errorDownloadDubbing')
                        }}</span
                      >
                    </v-tooltip> -->
                    </div>
                    <!-- <v-icon
                    color="red"
                    size="24px"
                    @click="handleConfirmDeleteDubbing(dubbing)"
                  >
                    mdi-delete
                  </v-icon> -->
                  </div>
                  <div
                    class="d-flex align-center"
                    v-if="
                      dubbing.status === 'QUEUE' || dubbing.status === 'RUNNING'
                    "
                  >
                    <div
                      class="mr-1 d-flex align-center"
                      style="position: relative"
                    >
                      <v-progress-circular
                        :size="16"
                        :width="3"
                        color="brand"
                        style="top: 0; position: absolute"
                      ></v-progress-circular>
                      <v-progress-circular
                        :size="16"
                        :width="3"
                        color="brand"
                        indeterminate
                      ></v-progress-circular>
                    </div>
                    <v-tooltip bottom persistent :close-delay="5000">
                      <template v-slot:activator="{ on, attrs }">
                        <v-tag
                          v-bind="attrs"
                          v-on="on"
                          type="default"
                          class="ml-1"
                        >
                          {{
                            $i18next.t(
                              'message.ai.dubbings.modal.auto.final_screen.title'
                            )
                          }}</v-tag
                        >
                      </template>
                      <span>{{
                        $i18next.t('message.ai.subtitles.tooltipWait')
                      }}</span>
                    </v-tooltip>
                  </div>
                  <div
                    class="d-flex align-center"
                    v-else-if="
                      ['UPLOADED', 'DRAFT', 'CONVERTING'].includes(
                        dubbing.status
                      ) ||
                      (!dubbing.hasOwnProperty('status') &&
                        dubbing.type === 'UPLOADED')
                    "
                  >
                    <span class="ml-2 secondaryText--text caption noIbar">
                      <v-icon>mdi-progress-upload</v-icon>
                      {{ $t('message.converting') }}...
                    </span>
                  </div>
                  <v-tooltip
                    v-if="
                      dubbing.status !== 'QUEUE' && dubbing.status !== 'RUNNING'
                    "
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <base-btn
                        :disabled="loading"
                        type="neutral"
                        class="panda-icons --dubbings"
                        @click="handleConfirmDeleteDubbing(dubbing)"
                      >
                        <img
                          style="display: flex"
                          v-bind="attrs"
                          v-on="on"
                          :src="
                            $vuetify.theme.dark
                              ? require('@/assets/remove-dark.svg')
                              : require('@/assets/remove.svg')
                          "
                          fill-class-name="fill-color"
                          fill="var(--v-brand-lighten1)"
                          width="16px"
                        />
                      </base-btn>
                    </template>
                    <span>{{ $t('message.pages.video.delete') }}</span>
                  </v-tooltip>
                  <v-menu
                    v-if="
                      dubbing.status !== 'QUEUE' && dubbing.status !== 'RUNNING'
                    "
                    min-width="215px"
                    offset-y
                    bottom
                    left
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <base-btn
                        type="neutral"
                        class="--dubbings"
                        :disabled="dubbing.status !== 'CONVERTED'"
                        icon="mdi-dots-vertical"
                        v-bind="attrs"
                        v-on="on"
                        color="neutral-light"
                      ></base-btn>
                    </template>
                    <v-list dense>
                      <!-- <v-list-item>
                        <v-list-item-title
                          style="color: #f44336"
                          @click="toggleVisibleDub(dubbing)"
                        >
                          <span class="body-regular-smaller">{{
                            downloadDubbingItems[dubbing.id] &&
                            downloadDubbingItems[dubbing.id].hidden
                              ? $i18next.t('message.ai.dubbings.showDub')
                              : $i18next.t('message.ai.dubbings.hiddenDub')
                          }}</span>
                        </v-list-item-title>
                      </v-list-item> -->
                      <v-list-item>
                        <v-list-item-title
                          style="color: #f44336"
                          @click="getDubbingAudio(dubbing)"
                          :disabled="
                            downloadDubbingItems[dubbing.id] &&
                            downloadDubbingItems[dubbing.id].errorMsg.error
                          "
                          @submit="
                            $emit('setDownloadServer', $event)
                            $nextTick(() => $refs.downloadAudioForm.submit())
                          "
                        >
                          <span class="body-regular-smaller">{{
                            $i18next.t('message.ai.dubbings.downloadDub')
                          }}</span>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title
                          style="color: #f44336"
                          @click="handleConfirmDeleteDubbing(dubbing)"
                        >
                          <span
                            class="body-regular-smaller"
                            style="color: #f44336"
                            >{{
                              $i18next.t('message.ai.dubbings.removeDub')
                            }}</span
                          >
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </v-row>
            <base-btn
              type="secondary"
              class="mt-2"
              :class="{ 'mt-4': !allDubbings.length }"
              size="small"
              @click="handleOpenAddDubbing"
              ><v-icon>mdi-plus</v-icon>
              {{ $i18next.t('message.ai.dubbings.addDubbing') }}</base-btn
            >
            <v-card v-if="errors.audioRemove" class="mt-1" flat width="100%">
              <span class="red--text caption align-text">
                <v-icon color="red" size="18" class="pb-1 pr-1">
                  mdi-alert-circle
                </v-icon>
                {{ errors.unknownErrorsMsg
                }}<template v-if="errors.unknownErrorsCode"
                  >. Code:

                  {{ errors.unknownErrorsCode }}</template
                >
              </span>
            </v-card>
          </template>
        </template>
      </div>
    </v-row>

    <template v-if="!allDubbings.length && !loadings.fetching">
      <v-row no-gutters>
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex flex-column">
            <span class="body-bold-base neutral-20-dark--text">{{
              $i18next.t('message.ai.dubbings.availableDubs')
            }}</span>
            <span class="body-regular-smaller neutral-40-light--text">{{
              $i18next.t('message.ai.dubbings.notCreatedDubs')
            }}</span>
          </div>
        </div>
      </v-row>
      <v-row no-gutters class="mt-4">
        <v-col cols="12">
          <base-btn type="secondary" size="small" @click="handleOpenAddDubbing">
            <v-icon>mdi-plus</v-icon>
            {{ $i18next.t('message.ai.dubbings.addDubbing') }}
          </base-btn>
        </v-col>
      </v-row>
    </template>
    <template v-if="!loadings.fetching">
      <v-divider class="my-8" />
      <v-row no-gutters>
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex flex-column">
            <span class="body-bold-base neutral-20-dark--text">{{
              $i18next.t('message.ai.dubbings.goBeyondIa')
            }}</span>
            <span class="body-regular-smaller neutral-40-light--text">{{
              $i18next.t('message.ai.dubbings.createWithIa')
            }}</span>
          </div>
        </div>
      </v-row>
      <v-row no-gutters>
        <v-col
          v-for="(dub, index) in unusedDubbingLangCodesAi.slice(0, 3)"
          :key="`${index}__dub`"
          style="display: flex; justify-content: space-between"
          cols="12"
          class="py-2"
        >
          <div class="d-flex align-center" style="gap: 16px">
            <FlagCards :items="[dub.country]" />
            <span class="body-regular-small neutral-20-dark--text">
              {{ dub.label }}
            </span>
          </div>
          <base-btn
            type="tertiary"
            size="small"
            @click="handleOpenReadyModal(dub)"
          >
            {{ $i18next.t('message.ai.dubbings.generate') }}
          </base-btn>
        </v-col>
        <v-col
          class="py-2"
          cols="12"
          style="display: flex; justify-content: space-between"
        >
          <div class="d-flex align-center" style="gap: 16px">
            <v-icon style="font-size: 16px" class="neutral-40-light--text">
              panda-globe
            </v-icon>
            <span class="body-regular-small neutral-20-dark--text">{{
              $i18next.t('message.ai.dubbings.moreLanguages')
            }}</span>
          </div>
          <base-btn type="tertiary" size="small" @click="handleOpenReadyModal">
            {{ $i18next.t('message.ai.dubbings.generate') }}
          </base-btn>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="12">
          <base-btn type="secondary" size="small" @click="handleOpenReadyModal">
            <v-icon>mdi-plus</v-icon>
            {{ $i18next.t('message.ai.dubbings.generateDubbing') }}
          </base-btn>
        </v-col>
      </v-row>
    </template>
    <form
      ref="downloadAudioForm"
      method="post"
      :action="downloadAudioUrl"
      style="display: none"
    >
      <input
        ref="downloadInput"
        name="Authorization"
        :value="authToken"
        type="hidden"
      />
    </form>
    <AiDeleteModal
      :title="$i18next.t('message.ai.dubbings.deleteDubTitle')"
      modalKey="Dubbing"
      :description="$i18next.t('message.ai.dubbings.deleteDubMessage')"
      :subtitle="(getLangCodeBySrcLang(dubbingToBeDeleted.lang) || {}).label"
      @confirm="
        $root.$emit('closeAiDeleteModalDubbing'),
          $root.$emit('openAiDeleteConfirmModalDubbing')
      "
    />
    <AiConfirmDeleteModal
      :title="$i18next.t('message.ai.dubbings.deleteDubTitle')"
      :onConfirmLogin="handleDeleteDubbing"
      modalKey="Dubbing"
    />
  </v-card>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import AiDeleteModal from '@/components/AddSubtitleModal/AiDeleteModal.vue'
import AiConfirmDeleteModal from '@/components/AddSubtitleModal/AiConfirmDeleteModal.vue'
import downloadUrlMixin from '@/utils/downloadUrl.mixin.js'
import i18n from '@/translations/lang'
import videosApi from '@/services/videosApi'
import aiworkflowApi from '@/services/aiworkflowApi'
import aiWorkflowMixin from '@/utils/aiWorkflow.mixin'
import linkHelper from '@/utils/linkHelper.mixin.js'
import Storage from '@/utils/Storage'
import FlagCards from '@/components/FlagCards.vue'
import globeIcon from '@/assets/pandaIcons/globe.svg'
import { ENV_CONFIG, BACKUP_DOWNLOADER_SERVER } from '@/config/envs'

export default {
  name: 'VideoPlayerDubbings',
  mixins: [linkHelper, aiWorkflowMixin, downloadUrlMixin],
  components: {
    AiDeleteModal,
    AiConfirmDeleteModal,
    FlagCards,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
    hasEdit: {
      type: Array,
    },
  },
  data: () => ({
    allAiWorkflowData: [],
    loadAiTimeout: null,
    videoInfoInterval: null,
    dubbingToBeDeleted: {},
    langsBeingRemoved: [],
    globeIcon,
    showTooltipError: false,
    authToken: false,
    downloadDubbingItems: [],
    errors: {
      audioRemove: false,
      unknownErrorsCode: '',
      unknownErrorsMsg: '',
    },
    loadings: {
      audioDelete: false,
      fetching: true,
    },
    loopCheck: false,
    tabHidden: false,
  }),
  beforeDestroy() {
    this.allAiWorkflowData = []
    this.$root.$off('addAiWorkflowDubbing')
    this.UPDATE_GENERATING_DUBBING_DATA([])
    clearTimeout(this.loadAiTimeout)
    clearInterval(this.videoInfoInterval)
    this.loopCheck = false
  },
  async mounted() {
    this.videoId = this.liveVideoId ? this.liveVideoId : this.$route.params.id

    if (!this.subtitles) {
      this.$store.state.video.video.config.subtitles = []
    }
    if (!this.activeAudios) {
      this.$store.state.video.video.audios = []
    }
    const _this = this
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState == 'visible') {
        this.tabHidden = false
        if (this.loopCheck) {
          this.loadAiTimeout = setTimeout(
            () => _this.handleFetchDubbings(true),
            10 * 1000
          )
        }
        if (this.hasAConvertingAudio(this.allDubbings)) {
          this.setupVideoInfoInterval()
        }
      } else {
        this.tabHidden = true
        clearTimeout(this.loadAiTimeout)
        clearInterval(this.videoInfoInterval)
      }
    })

    this.allDubbings.forEach((dubbing) => {
      this.downloadDubbingItems = {
        ...this.downloadDubbingItems,
        [dubbing.id]: {
          loading: false,
          hidden: false,
          errorMsg: {
            error: false,
            text: i18n.t('message.ai.dubbings.error'),
          },
        },
      }
    })

    this.handleFetchDubbings()
    this.$root.$on('addAiWorkflowDubbing', this.handleFetchDubbings)
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      profile: (state) => state.video.profile,
      profile_id: (state) => state.video.profile_id,
      subtitles: (state) => state.video.video.config.subtitles,
    }),
    isLoading() {
      return Boolean(
        Object.values(this.loadings).filter((value) => value).length
      )
    },
    allDubbings: {
      get() {
        const activeAudios = this.activeAudios ?? []
        let audiosFromVideo = this.video.audios ?? []
        if (audiosFromVideo.length > 0) {
          audiosFromVideo = audiosFromVideo.filter((audio) => {
            return !activeAudios.some(
              (activeAudio) => activeAudio.lang === audio.lang
            )
          })
        }
        const dubbingLanguages = this.dubbingGeneratingData.map(
          (dubbing) => dubbing.metadata?.from_lang
        )
        audiosFromVideo = audiosFromVideo.filter(
          (audio) => !dubbingLanguages.includes(audio.lang)
        )

        const audios = activeAudios.concat(audiosFromVideo)

        const list = [...audios, ...this.dubbingGeneratingData]

        return list
      },
      cache: false,
    },
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    returnDubbingSkippedMessage() {
      const noWordsFound = this.allAiWorkflowData.some(
        (item) => item.metadata?.no_words_found
      )
      return noWordsFound
        ? this.$i18next.t('message.ai.noWordsFound')
        : this.$i18next.t('message.ai.skipped')
    },
    videoAudios() {
      return this.video.audios ?? []
    },
  },
  methods: {
    ...mapActions('video', ['fetchSubtitles']),
    handleKnowMore() {
      const link = this.getAiDubbingLink()
      window.open(link, '_blank')
    },
    handleConfirmDeleteDubbing(dubbing) {
      this.dubbingToBeDeleted = dubbing
      this.$root.$emit('openAiDeleteModalDubbing')
    },
    getBlockingItem(dubbing) {
      const blockItem = this.allAiWorkflowData.filter((item) => {
        if (item.metadata?.dependent_works) {
          return item.metadata.dependent_works.includes(dubbing.id)
        } else if (item.metadata?.dependent_work) {
          return dubbing.id === item.metadata.dependent_work
        }
        return false
      })
      if (!blockItem.length) return 'null'
      return this.getLangCodeBySrcLang(
        blockItem[0].metadata.to_lang ?? blockItem[0].metadata.from_lang
      ).label
    },
    toggleVisibleDub(dubbing) {
      this.downloadDubbingItems[dubbing.id].hidden =
        !this.downloadDubbingItems[dubbing.id].hidden
    },
    async getDubbingAudio(dubbing) {
      this.downloadDubbingItems[dubbing.id].loading = true
      let downloadServer = Storage.getItem('downloaderServer')
      if (!downloadServer) {
        downloadServer = BACKUP_DOWNLOADER_SERVER
      }
      let subdomain = `download-${downloadServer}`
      let port = '7443'
      let path = 'download'
      if (ENV_CONFIG !== 'production') {
        subdomain = `download-staging-${downloadServer}`
        port = '7442'
      }
      if (dubbing.id) {
        path = `${dubbing.id}/download`
      }
      let downloadLink = `https://${subdomain}.pandavideo.com:${port}/audios/${path}`
      this.authToken = Storage.getItem('accessToken')
      try {
        let data = await fetch(downloadLink, {
          headers: {
            Authorization: `Bearer ${this.authToken}`,
          },
        }).then((res) => (data = res))
        let blob = await data.blob()
        let url = URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = `${this.video.title}-${dubbing.lang}.mp3`
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
        this.downloadDubbingItems[dubbing.id].loading = false
      } catch (error) {
        console.error(error)
        this.downloadDubbingItems[dubbing.id].errorMsg.error = true
      }
    },
    async deleteAiWorkflow(dubbing) {
      this.loadings.audioDelete = true
      const langsBeingRemovedlastIndex = this.langsBeingRemoved.length - 1
      this.langsBeingRemoved.push(
        dubbing.metadata.to_lang ?? dubbing.metadata.from_lang
      )
      await aiworkflowApi.deleteAiWorkflow(dubbing.id)

      const newData = this.dubbingGeneratingData.filter(
        (item) =>
          (item.metadata?.to_lang ?? item.metadata?.from_lang) !=
          (dubbing.metadata?.to_lang ?? dubbing.metadata?.from_lang)
      )
      this.UPDATE_GENERATING_DUBBING_DATA(newData)
      this.langsBeingRemoved.splice(langsBeingRemovedlastIndex, 1)

      this.loadings.audioDelete = false
    },
    async handleDeleteDubbing() {
      try {
        if (this.dubbingToBeDeleted?.metadata) {
          await this.deleteAiWorkflow(this.dubbingToBeDeleted)
        } else {
          await this.handleRemoveDubbing(this.dubbingToBeDeleted)
        }
      } catch (e) {
        console.error(e)
        if (e?.response?.data) {
          this.errors.unknownErrorsCode = e.response.data.errCode
          this.errors.unknownErrorsMsg = e.response.data.errMsg
        } else if (e?.message) {
          this.errors.generate = e.message
        } else {
          this.errors.unknownErrorsMsg = i18n.t(
            'message.errors.unexpectedError'
          )
        }
        this.errors.audioRemove = true
      }
      this.$root.$emit('closeAiDeleteConfirmModalSubtitle')
    },
    async handleFetchDubbings(isLoopingCheck) {
      if (this.tabHidden && this.loopCheck) return
      if (isLoopingCheck) {
        this.loopCheck = isLoopingCheck
      }

      const { data } = await aiworkflowApi.getAiWorkflow(this.videoId)
      this.allAiWorkflowData = data
      const unfinishedDubbings = data.filter(
        (item) => item.status !== 'FINISHED' && item.type === 'DUBBING'
      )

      const onlyInA = this.dubbingGeneratingData.filter(
        (leftValue) =>
          !unfinishedDubbings.some(
            (rightValue) => leftValue.id === rightValue.id
          ) && data.some((item) => item.id === leftValue.id)
      )

      const _this = this
      if (onlyInA.length) {
        onlyInA.map((item) => {
          if (Array.isArray(_this.activeAudios)) {
            this.UPDATE_AUDIO_LIST([
              ...this.activeAudios,
              {
                id: item.metadata.audio_id,
                lang: item.metadata.from_lang,
                label: this.getLangLabelBySrclang(item.metadata.from_lang),
              },
            ])
          } else {
            this.UPDATE_AUDIO_LIST([
              {
                id: item.metadata.audio_id,
                lang: item.metadata.from_lang,
                label: this.getLangLabelBySrclang(item.metadata.from_lang),
              },
            ])
          }
          window.db.videos.update(this.videoId, {
            audios: this.activeAudios.map((item) => item.lang),
          })
          this.$root.$emit('forceRecomputeEmbedPage')
        })
        this.fetchSubtitles({
          libraryId: this.video.pullzone_name,
          videoId: this.video.video_external_id,
        })
      }

      this.UPDATE_GENERATING_DUBBING_DATA(unfinishedDubbings)
      const dubbingsBeingGenerated = this.dubbingGeneratingData.filter(
        (item) => item.status === 'QUEUE' || item.status === 'RUNNING'
      )

      if (!isLoopingCheck) {
        this.loadings.fetching = false
      }

      if (dubbingsBeingGenerated.length > 0) {
        _this.loadAiTimeout = setTimeout(
          () => _this.handleFetchDubbings(true),
          10 * 1000
        )
      } else {
        this.loopCheck = false
      }
    },
    redirectLink() {
      const link = this.$i18next.t('message.ai.dubbings.tooltipError.href')
      window.open(link, '_blank')
    },
    handleOpenReadyModal(selectedLang) {
      this.$root.$emit('openDubbingModal', {
        videoId: this.videoId,
        initialState: true,
        selectedLang,
      })
    },
    ...mapMutations('video', [
      'UPDATE_VIDEO',
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_AUDIO_LIST',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleOpenAddDubbing() {
      this.$root.$emit('openDubbingModal', { videoId: this.videoId })
    },
    handleSnackbar(item) {
      if (!item) {
        item = this.$i18next.t('message.navDrawer.successMessage')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
    async handleRemoveDubbing(dubbingItem) {
      this.clearErrors()
      this.clearErrorMsg()
      const langsBeingRemovedlastIndex = this.langsBeingRemoved.length - 1
      this.langsBeingRemoved.push(dubbingItem.lang)
      this.loadings.audioDelete = true
      try {
        await videosApi.deleteAudioFromVideo(dubbingItem.id)
        this.loadings.audioDelete = false
        const audiosList = this.activeAudios.filter(
          (audio) => audio.lang != dubbingItem.lang
        )
        this.UPDATE_AUDIO_LIST(audiosList)
        this.$forceUpdate()
        this.$root.$emit('forceRecomputeEmbedPage')
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: this.$i18next.t('message.ai.dubbings.removeSuccess'),
        })
        this.langsBeingRemoved.splice(langsBeingRemovedlastIndex, 1)
        this.loadings.audioDelete = false
      } catch (e) {
        if (e?.response?.data) {
          this.errors.unknownErrorsCode = e.response.data.errCode
          this.errors.unknownErrorsMsg = e.response.data.errMsg
        } else {
          this.errors.unknownErrorsMsg = i18n.t(
            'message.errors.unexpectedError'
          )
        }
        this.errors.audioRemove = true
        this.loadings.audioDelete = false

        this.langsBeingRemoved.splice(langsBeingRemovedlastIndex, 1)
        this.loadings.audioDelete = false
        throw e
      }
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
    },
    clearErrorMsg() {
      this.errors.unknownErrorsMsg = ''
    },
    onScroll() {
      this.scrollInvoked++
    },
    changeState() {
      this.video.config.subtitles = this.subtitles
      this.UPDATE_VIDEO(this.video)
    },
    setupVideoInfoInterval() {
      clearInterval(this.videoInfoInterval)
      this.videoInfoInterval = setInterval(async () => {
        try {
          const { data } = await videosApi.getAVideo(this.videoId)
          const currentPath = this.$route?.fullPath || ''
          if (
            !this.hasAConvertingAudio(data.audios) ||
            !currentPath.includes(this.videoId)
          ) {
            clearInterval(this.videoInfoInterval)
          }
        } catch (error) {
          console.error('Error in video info interval:', error)
          clearInterval(this.videoInfoInterval)
        }
      }, 10000)
    },
    hasAConvertingAudio(dubbingArray) {
      const convertingStatuses = ['UPLOADED', 'DRAFT', 'CONVERTING']
      return dubbingArray.some(
        (item) =>
          convertingStatuses.includes(item.status) ||
          (!item.hasOwnProperty('status') && item.type === 'UPLOADED')
      )
    },
  },
  watch: {
    allDubbings: {
      handler(allDubbings) {
        console.log(allDubbings)
        if (this.hasAConvertingAudio(allDubbings)) this.setupVideoInfoInterval()
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped></style>

<style scoped lang="scss">
::v-deep .dubbing-container * {
  font-family: 'Rubik', sans-serif !important;
}
.hidden-dub {
  color: varFigma(neutral-70) !important;
}
.neutral-20-dark--text {
  color: varFigma(neutral-20-dark);
}
.neutral-40-light--text {
  color: varFigma(neutral-40-light);
}
.v-card__ai-empty-state {
  border-radius: 4px;
  border: 1px solid var(--v-neutral-lighten3);

  &-info {
    margin-top: 1px;
    border-radius: 4px;
    border: 1px solid var(--v-brand-base);

    img {
      width: 48px;
      margin-right: 10px;
      margin-bottom: 2px;
    }

    .ai-chip {
      position: absolute;
      bottom: 6px;
      right: 10px;
      bottom: 4px;
    }
  }
}

.panda-ia-chip {
  background: var(--v-brand-lighten2) !important;
}
.base-button.--dubbings {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  padding: 0 !important;
  width: 30px !important;
  height: 30px !important;
}
::v-deep .v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
::v-deep .v-list-item.theme--dark:hover {
  background-color: #292b35 !important;
}
::v-deep .v-input--selection-controls__input {
  margin-right: 0px !important;
}
v-list-item-title.disabled-v-list-item-title {
  color: varFigma(neutral-70) !important;
}
::v-deep .v-list-item {
  cursor: pointer;
  transition: background-color 0.3s;
}
.disabled-v-list-item {
  cursor: not-allowed;
}
</style>
